import { Link } from 'react-router-dom';
import { PageHeader, Hero } from '../components/PageComponents';
import './CaseManagement.css';

const features = [
  {
    id: 'self-service',
    title: 'Customer Self-Service Module',
    description: 'Customer self-service module provides a collection of services and facilities for customers to obtain answers to the questions that they wish to raise.',
  },
  {
    id: 'faq-search',
    title: 'FAQ and Search widgets',
    description: 'Widgets that can be embedded in relevant sections of the website. This provides an Interactive search panel that provides in line knowledge base search for the customers.',
    image: '/Images/CM2_search.jpg',
    alt: 'FAQ and Search widgets',
    hasImage: true,
  },
  {
    id: 'multi-channel',
    title: 'Multi Channel Case Registration',
    description: 'Smart Case Management provides case registration forms that are designed for specific channels. The formatting and layout of the forms are responsive to channel type. Smart Case Management supports receiving enquiry in English and Chinese characters.',
    image: '/Images/CM2_Multi.jpg',
    alt: 'Multi Channel Case Registration',
    fullWidth: true,
  },
  {
    id: 'knowledge-base',
    title: 'Self Service Knowledge Base',
    description: 'The Knowledge Base module provides customers and Case Officers with the ability to search and browse resources such as FAQs, articles and past case information.',
  },
  {
    id: 'case-management',
    title: 'Case and Customer Management Module',
    description: 'Case and Customer Management module tracks the lifecycle and development of cases as they are processed by the various Case Officers. The case management module has an integrated and customizable workflow engine to manage the assignment, reassignment and routing of cases, within internal departments as well as to external parties. Agent Dashboards provides visual charts and summarized tabular data for quick overview of the work on hand.',
    image: '/Images/CM2_Case.jpg',
    alt: 'Case Management Dashboard',
    hasImage: true,
  },
  {
    id: 'service-level',
    title: 'Service Level Management',
    description: 'Smart Case Management provides the ability to define the Service Level Agreement (SLA). All cases received are tracked for compliance with established KPIs. Overdue cases are flagged out in either the Analytics or the Agent Dashboard modules.',
  },
  {
    id: 'ml-features',
    title: 'Machine Learning Features',
    description: 'Smart Case Management uses machine learning techniques to suggest best matched replies/case resolution based on past cases. It also uses various automated clustering techniques to assign meta-tags to cases for better classification and analytics.',
  },
  {
    id: 'analytics',
    title: 'Analytics and reports',
    description: 'Analytics and reports module captures usage statistics and present the information either in tabular form or via visual charts to Case Officers. All reports are web-based and exportable to MS Excel format.',
    image: '/Images/CM2_analytics.jpg',
    alt: 'Analytics and Reports',
    hasImage: true,
  },
  {
    id: 'web-reports',
    title: 'Web based Reports and Analytics',
    description: 'The System features a standard set of reports for Case Management Module and Knowledge Base. All reports are web-based and exportable to MS Excel, CSV format, export to PDF.',
  },
];

function CaseManagement() {
  return (
    <>
      <Hero 
        imageSrc="/Images/Case-Mgmt-Pic.jpg"
        imageAlt="Smart Case Management System"
        title="Smart Case Management System"
        subtitle="Web-based customer support software"
        imagePosition="center 25%"
      />

      <div className="container">
        <section className="section">
          <div className="panel">
            <h2 className="centered-text">Overview</h2>
            <p className="centered-text">Smart Case Management is a web based solution that provides a one-stop integrated solution for managing customer generated feedback, enquiries, suggestion, complaints and investigative cases.</p>
          </div>
        </section>

        <section className="section">
          <h2 className="centered-text mb-lg">Features</h2>
          
          <div className="features-list">
            {features.map((feature) => (
              <div key={feature.id} className="feature-item">
                <div className="panel">
                  <div className={`feature-content ${feature.hasImage ? 'has-image' : ''}`}>
                    <div className="feature-text">
                      <h4>{feature.title}</h4>
                      <p>{feature.description}</p>
                    </div>
                    
                    {feature.hasImage && (
                      <div className="feature-image">
                        <img src={feature.image} alt={feature.alt} loading="lazy" />
                      </div>
                    )}
                  </div>
                  
                  {feature.fullWidth && feature.image && (
                    <div className="feature-image-full">
                      <img src={feature.image} alt={feature.alt} loading="lazy" />
                    </div>
                  )}
                </div>
              </div>
            ))}
          </div>
        </section>

        <section className="section section-sm">
          <div className="panel panel-highlight">
            <div className="row" style={{ alignItems: 'center' }}>
              <div className="col-9 large-9 columns">
                <h3>Get in touch!</h3>
                <p>If you're considering using our Smart Case Management System or are interested to build a custom solution, please complete the enclosed form and we will get back to you right away.</p>
              </div>
              <div className="col-3 large-3 columns text-right">
                <Link to="/contact" className="button button-primary">Contact Us</Link>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
}

export default CaseManagement;
